import React from 'react';
import { Card, CardBody, Row, Col } from 'reactstrap';
import numeral from 'numeral';
import 'numeral/locales/pt-br';
import styles from './ReportCard.module.scss';

interface PricingModelSummaryCardProps {
  pricingModel: 'CPM' | 'CPV' | 'CPC';
  data: any;
  onRefresh: () => void;
  loading: boolean;
}

const PricingModelSummaryCard: React.FC<PricingModelSummaryCardProps> = ({
  pricingModel,
  data,
  onRefresh,
  loading
}) => {
  if (!data || data.purchaseImpressions <= 0) {
    return null;
  }

  const numeralInteger = '0,0';
  const numeralDecimalFormat = '0.00';

  const calculateRemaining = () => {
    const contracted = data.purchaseImpressions || 0;
    
    if (pricingModel === 'CPM') {
      return contracted - (data.impression || 0);
    } else if (pricingModel === 'CPV') {
      return contracted - (data.viewable || 0);
    } else if (pricingModel === 'CPC') {
      return contracted - (data.click || 0);
    }
    
    return contracted - (data.impression || 0);
  };

  return (
    <Card className={styles.reportCard}>
      <CardBody className="p-0">
        <Row className="g-0">
          <Col xs="auto" className={styles.pricingModelLabel}>
            {pricingModel}
          </Col>
          <Col className={styles.metricCard}>
            <div className={styles.metricLabel}>Contratado</div>
            <div className={styles.metricValue}>
              {numeral(data.purchaseImpressions || 0).format(numeralInteger)}
            </div>
          </Col>
          <Col className={styles.metricCard}>
            <div className={styles.metricLabel}>Entregues</div>
            <div className={styles.metricValue}>
              {numeral(data.impression || 0).format(numeralInteger)}
            </div>
          </Col>
          <Col className={styles.metricCard}>
            <div className={styles.metricLabel}>Restantes</div>
            <div className={styles.metricValue}>
              {numeral(calculateRemaining()).format(numeralInteger)}
            </div>
          </Col>
          <Col className={styles.metricCard}>
            <div className={styles.metricLabel}>Visualizadas</div>
            <div className={styles.metricValue}>
              {numeral(data.viewable || 0).format(numeralInteger)}
            </div>
          </Col>
          <Col className={styles.metricCard}>
            <div className={styles.metricLabel}>Visibilidade</div>
            <div className={styles.metricValue}>
              {data.impression && data.viewable 
                ? `${numeral((data.viewable / data.impression) * 100).format(numeralDecimalFormat)}%`
                : '0%'
              }
            </div>
          </Col>
          <Col className={styles.metricCard}>
            <div className={styles.metricLabel}>Entrega</div>
            <div className={styles.metricValue}>
              {data.purchaseImpressions && data.impression 
                ? `${numeral((data.impression / data.purchaseImpressions) * 100).format(numeralDecimalFormat)}%`
                : '0%'
              }
            </div>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default PricingModelSummaryCard;
